import { useMemo } from 'react';
import { useQueryClient } from 'react-query';
import { useSelector } from 'react-redux';
import { getQueryKeys } from '../queries/queryKeys';

const useFlatsGridState = () => {
  const queryClient = useQueryClient();

  const currentHouse = useSelector(
    (state) => state.housingStockStore.currentHouse
  );

  const flatsGridQueryKey = useMemo(
    () => getQueryKeys.flatsGrid(currentHouse?.houseId),
    [currentHouse]
  );

  const flatsGridState = queryClient.getQueryState(flatsGridQueryKey);

  return { flatsGridState, flatsGridQueryKey };
};

export default useFlatsGridState;
